<script setup lang="ts">
const isSticky = ref(false);

const handleScroll = () => {
	isSticky.value = window.scrollY > 20;
};

const initializeHamburgerAnimation = () => {
	const mobileNavBurger = document.querySelector(".mobile-nav-burger");
	const navbarCollapse = document.querySelector(".navbar-collapse");

	if (mobileNavBurger) {
		mobileNavBurger.addEventListener("click", (e) => {
			e.preventDefault();
			mobileNavBurger.classList.toggle("is-active");

			if (navbarCollapse) {
				navbarCollapse.classList.toggle("show");
			}
		});
	}
};

const domain = window.location.host.split(":")[0];
const env = domain.includes("localhost") ? "local" : domain.includes("ssldev") ? "dev" : domain.includes("ssltest") ? "test" : domain.includes("ssl.education.lu") ? "prod" : "other";

const isProd = env === "prod";

const config = useRuntimeConfig();

onMounted(() => {
	window.addEventListener("scroll", handleScroll);
	initializeHamburgerAnimation();
});

onUnmounted(() => {
	window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
	<div>
		<div v-if="!isProd"
			class="infos-interne">
			<div class="git-infos">
				<input id="click"
					type="checkbox" />
				<label for="click">{{ env.toLocaleUpperCase() }}</label>
				<span class="hidden">&nbsp;&nbsp;|&nbsp;&nbsp;{{ config.public.branchName }}</span>
			</div>
		</div>
		<nav class="navbar-main"
			role="navigation"
			aria-label="Menu principal">
			<div :class="`navbar-main-wrapper ${isSticky ? 'fixed-after-scroll' : ''}`">
				<div class="navbar navbar-expand-lg">
					<div class="alignwide">
						<a class="navbar-logo"
							href="/ifen/"
							aria-label="Accueil - Logo de l'Institut de Formation de l'Éducation Nationale">
							<Icon name="svg:logo-ifen"
								size="87.535" />
							<Icon name="svg:logo-ifen-scroll"
								size="33"
								class="logo-scroll" />

							<img src="/img/pictos/divers/logo_header_mobile.png"
								alt="Logo de l'Institut de Formation de l'Éducation Nationale" />
						</a>
						<div class="mobile-nav">
							<ul class="mobile-nav-pictos">
								<li>
									<nuxt-link to="/"
										aria-label="Accéder au catalogue">
										<img src="/img/pictos/divers/picto_catalogue_mobile.svg"
											width="30"
											height="30"
											alt="Pictogramme Catalogue mobile" />
									</nuxt-link>
								</li>
								<li>
									<a href="/ifen/my/">
										<img src="/img/pictos/divers/picto_myifen_mobile.svg"
											width="30"
											height="30"
											alt="Pictogramme MyIfen mobile" />
									</a>
								</li>
							</ul>
							<button class="collapsed mobile-nav-burger"
								role="bouton"
								type="button"
								aria-label="Toggle navigation">
								<span />
								<span />
								<span />
							</button>
						</div>

						<div class="collapse navbar-collapse">
							<div class="navbar-nav ml-auto">
								<div class="navbar-nav-wrapper">
									<div class="menu-menu-principal-container">
										<ul id="menu-menu-principal"
											class="menu">
											<li class="menu-item">
												<a href="/ifen/linstitut/">L’Institut</a>
											</li>
											<li class="menu-item">
												<a href="/ifen/je-suis/">Je suis</a>
											</li>
											<li class="menu-item">
												<a href="/ifen/ressources/">Ressources</a>
											</li>
											<li class="menu-item">
												<a href="/ifen/contact/">Contact</a>
											</li>
											<li class="wp-block-button menu-item">
												<nuxt-link to="/"
													aria-label="Accéder au catalogue">
													<span>
														<Icon name="svg:catalog"
															size="20" />
														Catalogue
													</span>
												</nuxt-link>
											</li>
											<li class="wp-block-button menu-item">
												<a href="/ifen/my/">
													<span>
														<Icon name="svg:myifen"
															size="13.667" />
														MyIfen
													</span>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
	</div>
</template>
